var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45488 6.7394L13 8.34717L11.6198 2.74106L9.89804 4.39397L7.12069 1.5009C7.02641 1.40269 6.89615 1.34717 6.76 1.34717C6.62385 1.34717 6.49359 1.40269 6.39931 1.5009L4.36 3.62518L1.36069 0.500902C1.16946 0.301697 0.85294 0.295237 0.653735 0.486475C0.454529 0.677711 0.44807 0.994228 0.639307 1.19343L3.99931 4.69343C4.09359 4.79165 4.22385 4.84717 4.36 4.84717C4.49615 4.84717 4.62641 4.79165 4.72069 4.69343L6.76 2.56916L9.17665 5.0865L7.45488 6.7394Z",
    fill: "#dc3c3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrease);
export default __webpack_public_path__ + "static/media/decrease.60ff516cac1978419a0546604e403a9a.svg";
export { ForwardRef as ReactComponent };